import axios from "axios";
import React, { useEffect, useState } from "react";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { useTranslation } from "react-i18next";

import ava2 from "../../../assets/img/ava2.png";
import { API_BASE_URL } from "../../../config/config";
import "./style.css";

function ChiefBlocks({ departmentId }) {
  const [departmentDetails, setDepartmentDetails] = useState(null);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (!departmentId) return;

    const lang = i18n.language;
    const langCode = lang === "ru" ? "ru" : lang === "tj" ? "tj" : "en";

    axios
      .get(
        `${API_BASE_URL}/api/departaments/${departmentId}?lang=${langCode}`,
        {
          headers: {
            accept: "text/plain",
            "api-version": "1.0",
          },
        }
      )
      .then((response) => {
        setDepartmentDetails(response.data);
      })
      .catch((error) => {
        console.error("Error fetching department details:", error);
      });
  }, [departmentId, i18n.language]);

  if (!departmentDetails || !departmentDetails.employees) {
    return null;
  }

  return (
    <Container>
      <Row>
        {departmentDetails.employees.map((employee, index) => (
          <Col sm lg="4" className="pb-5" key={index}>
            <Card className="w-100">
              <Card.Img
                variant="top"
                src={employee.image || ava2}
                className="fixed-image"
              />
              <Card.Body className="text-start">
                <Card.Title as="h4" className="employee-name">
                  {employee.name}
                </Card.Title>
                <Card.Text>
                  {employee.job}
                  <br />
                  <b>{t("DirectorPhone")}:</b> {employee.phone}
                  <br />
                  <b>Email:</b> {employee.email}
                  <br />
                  <b>{t("ReceptionSchedule")}</b>
                  <br />
                  {employee.schedule}
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default ChiefBlocks;
